import { graphql } from '../../../../graphql/generated';

export const DELETE_TEST_TUBE_IMAGE_MUTATION = graphql(`
  mutation DeleteTestTubeImage($id: ID!) {
    deleteTestTubeImage(id: $id) {
      id
    }
  }
`);
